(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
const icon = document.querySelector(".search__icon");
const search = document.querySelector(".ite-header__search-input");

icon.onclick = function () {
	search.classList.toggle("expand-search");
};

  } catch(e) { console.error(e); }
})();
})();
